/* eslint-disable key-spacing */
export const defaultButtonTheme = {
  disabled:                 'disabled',
  loading:                  'loading',
  wrapper:                  'button-wrapper',
};
/* eslint-enable key-spacing */
